import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
	return (
		<Typewriter
			options={{
				strings: ["Developer","Unconventional Thinker", "Problem Solver","Detail Oriented","Conscientious", "Self-Motivated","Code Cleanliness Obsession"],
				autoStart: true,
				loop: true,
				deleteSpeed: 20,
			}}
		/>
	);
}

export default Type;
